import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import {
  isRemoteShippingEnabled,
  onRemoteShippingChange,
} from "~/utils/logger";
import "./RemoteLogIndicator.css";

/**
 * Recording indicator in the footer. Only rendered when remote log shipping is
 * active on this session. Click opens a disclosure modal.
 */
export default function RemoteLogIndicator() {
  const [active, setActive] = useState(isRemoteShippingEnabled());
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const unsubscribe = onRemoteShippingChange((v) => setActive(v));
    setActive(isRemoteShippingEnabled());
    return unsubscribe;
  }, []);

  if (!active) return null;

  return (
    <>
      <button
        type="button"
        className="remote-log-indicator"
        onClick={() => setShowModal(true)}
        title="Logs de diagnóstico estão sendo enviados para análise pelo suporte. Clique para mais detalhes."
        aria-label="Coleta de logs de diagnóstico ativa"
        data-evo-id="footer-remote-log-indicator"
      >
        <span className="remote-log-indicator__dot" />
        <span className="remote-log-indicator__label">REC</span>
      </button>

      <Dialog
        header="Coleta de logs de diagnóstico"
        visible={showModal}
        onHide={() => setShowModal(false)}
        style={{ width: "min(520px, 92vw)" }}
        dismissableMask
        footer={
          <Button
            label="Entendi"
            icon="pi pi-check"
            onClick={() => setShowModal(false)}
            autoFocus
            data-evo-id="footer-remote-log-indicator-confirm"
          />
        }
      >
        <div style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
          <p>
            <strong>O que está acontecendo:</strong> a equipe de suporte
            habilitou o envio dos logs de diagnóstico desta sessão para ajudar a
            investigar um problema.
          </p>
          <p>
            <strong>O que é coletado:</strong> eventos internos do aplicativo —
            conexões, carregamento de dados, ordens, avisos e erros. Dados
            sensíveis (senhas, tokens) são removidos automaticamente antes do
            envio.
          </p>
          <p>
            <strong>Onde fica:</strong> os logs são armazenados de forma segura
            no servidor e automaticamente removidos após 30 dias.
          </p>
          <p>
            <strong>Por quanto tempo:</strong> a coleta é temporária e expira
            sozinha. Você também pode simplesmente sair e voltar mais tarde — o
            suporte encerra a coleta quando não precisar mais.
          </p>
        </div>
      </Dialog>
    </>
  );
}
